import { useEffect, useState } from 'react';
import axios from 'axios';
import { Download, ShieldCheck, Smartphone } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Public page employees open from the WhatsApp link to install the field tracking app
export default function AppDownload() {
  const [release, setRelease] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    axios.get(`${API}/app/version`).then((r) => setRelease(r.data)).catch(() => setError(true));
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50 flex items-start justify-center px-4 py-10">
      <div className="w-full max-w-md bg-white border-2 border-zinc-100 rounded-lg p-6 space-y-5">
        <img src="/anmol-logo.jpg" alt="Advanced Anmol Metcomp Pvt Ltd" className="h-10" />
        <div className="flex items-center gap-3">
          <Smartphone size={32} className="text-zinc-900" />
          <div>
            <h1 className="font-heading text-2xl font-extrabold uppercase tracking-tight text-zinc-900">Field Tracking App</h1>
            <p className="text-sm text-zinc-500">Download Android App</p>
          </div>
        </div>

        {error && <p className="text-red-700 font-medium">Could not load the app details. Please try again later.</p>}
        {release && !release.available && <p className="text-zinc-600">The app has not been published yet. Please check with HR.</p>}
        {release?.available && (
          <>
            <dl className="text-sm space-y-1">
              <div className="flex justify-between"><dt className="text-zinc-500">Current version</dt><dd className="font-bold" data-testid="download-version">{release.latest_version_name}</dd></div>
              <div className="flex justify-between"><dt className="text-zinc-500">Minimum supported version code</dt><dd className="font-bold">{release.minimum_supported_version_code}</dd></div>
              <div className="flex justify-between"><dt className="text-zinc-500">Size</dt><dd>{(release.size_bytes / 1024 / 1024).toFixed(1)} MB</dd></div>
            </dl>
            {release.release_notes && (
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-zinc-500 mb-1">Release notes</p>
                <p className="text-sm text-zinc-700 whitespace-pre-line">{release.release_notes}</p>
              </div>
            )}
            <a
              href={`${BACKEND_URL}${release.download_url}`}
              className="h-16 w-full bg-green-600 hover:bg-green-700 text-white text-xl font-extrabold uppercase tracking-wider rounded-sm flex items-center justify-center gap-3"
              data-testid="download-apk-button"
            >
              <Download size={24} /> Download APK
            </a>
            <div className="text-sm text-zinc-600 space-y-2">
              <p className="font-bold text-zinc-900">How to install</p>
              <ol className="list-decimal pl-5 space-y-1">
                <li>Tap <b>Download APK</b> and open the file when it finishes.</li>
                <li>If Android asks, allow <b>Install unknown apps</b> for your browser or WhatsApp, then go back.</li>
                <li>Tap <b>Install</b>. Updating keeps your login and saved locations.</li>
                <li>Open <b>Field Tracking</b> and log in with your attendance Employee ID and PIN.</li>
              </ol>
            </div>
            <div className="text-xs text-zinc-500 border-t-2 border-zinc-100 pt-3">
              <p className="flex items-center gap-1 font-bold text-zinc-700"><ShieldCheck size={14} /> SHA-256 checksum</p>
              <p className="font-mono break-all" data-testid="download-sha256">{release.sha256}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
